import apiClient from "./client";
import type {
  DisasterDetailsResponse,
  DisasterIdParam,
  GetDisasterDetailsParams,
} from "../types/disaster";

export const getDisasterDetails = async (
  disasterId: DisasterIdParam,
  params: GetDisasterDetailsParams
): Promise<DisasterDetailsResponse> => {
  const { data } = await apiClient.get<DisasterDetailsResponse>(
    `/disaster-details/${disasterId}`,
    {
      params: {
        order: params.order,
        sort: params.sort,
        page: params.page,
        limit: params.limit,
      },
    }
  );
  return data;
};
